import type { ButtonProps } from '@coursera/cds-core';

export const TOOLBAR_BUTTON_TYPES = {
  formatting: 'formatting',
  insertion: 'insertion',
  menu: 'menu',
} as const;

export type ToolbarButtonType = (typeof TOOLBAR_BUTTON_TYPES)[keyof typeof TOOLBAR_BUTTON_TYPES];

export type ButtonRole = ButtonProps['role'];
